import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import ProductSizeSelect from 'components/common/simpleSelectors/ProductSize';
// interfaces
import { ProductSizeSelectorProps } from 'interfaces';

const ProductSizeSelector: FC<ProductSizeSelectorProps> = ({
  name,
  title,
  handleChange,
  productTypeId,
  productSubTypeId,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <ProductSizeSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            productTypeId={productTypeId}
            subProductTypeId={productSubTypeId}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ProductSizeSelector;
